export const campsiteTypeColors: Record<string, string> = {
  regional: "grape",
  military: "red",
  federal: "green",
  state: "cyan",
  reservation: "teal",
  other: "gray",
};

export const campsiteTypeMap = {
  AMC: { label: "Appalachian Mountain Club", category: "regional" },
  AUTH: { label: "Authority", category: "regional" },
  BLM: { label: "US Bureau of Land Management", category: "federal" },
  BOR: { label: "US Bureau of Reclamation", category: "federal" },
  CNP: { label: "Canadian National Park", category: "federal" },
  COE: { label: "US Corps of Engineers", category: "federal" },
  CP: { label: "County/City/Regional Park", category: "regional" },
  MIL: { label: "Military Only", category: "military" },
  NF: { label: "US National Forest", category: "federal" },
  NM: { label: "National Monument", category: "federal" },
  NP: { label: "US National Park", category: "federal" },
  NRA: { label: "National Recreation Area", category: "federal" },
  NS: { label: "National Seashore", category: "federal" },
  NWR: { label: "National Wildlife Refuge", category: "federal" },
  PP: { label: "Canadian Provincial Park", category: "state" },
  PR: { label: "Canadian Provinical Reserve", category: "state" },
  RES: { label: "Native American Reservation", category: "reservation" },
  SB: { label: "State Beach", category: "state" },
  SCA: { label: "State Conservation Area", category: "state" },
  SF: { label: "State Forest", category: "state" },
  SFW: { label: "State Fish and Wildlife", category: "state" },
  SP: { label: "State Park", category: "state" },
  SPR: { label: "State Preserve", category: "state" },
  SR: { label: "State Reservation", category: "state" },
  SRA: { label: "State Recreation Area", category: "state" },
  SRVA: { label: "State Recreational Vehicle Area", category: "state" },
  TVA: { label: "Tennessee Valley Authority", category: "regional" },
  USFW: { label: "US Fish and Wildlife", category: "federal" },
  UTIL: { label: "Utility", category: "other" },
  UNK: { label: "Unknown Type", category: "other" },
};
